export const ifSupported = 'PerformanceObserver' in self && typeof PerformanceObserver === 'function';
export const totalEntryTypes = [
    'element',
    'first-input',
    'frame',
    'largest-contentful-paint',
    'layout-shift',
    'longtask',
    'mark',
    'measure',
    'navigation',
    'paint',
    'resource',
    'server'
];
//# sourceMappingURL=utils.js.map